import {
  ref
} from 'vue'

const recaptchaToken = ref(null)

export const useRecaptcha = () => {
  let run = false

  const initializeRecaptcha = (action = 'inquiry') => {
    if (run || recaptchaToken.value) {
      return
    }
    run = true

    if (typeof(grecaptcha) == 'undefined') {
      run = false
      setTimeout(initializeReCaptcha, 1000)
      return
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(window.app.common.recaptchaSiteKey, { action }).then((token) => {
        recaptchaToken.value = token
      })
    })
  }

  return {
    // variables
    recaptchaToken,
    // methods
    initializeRecaptcha,
  }
}
